<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import ProximaAulive from "./proxima-aulive";

export default {
  page: {
    title: "Próximas Aulives",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ProximaAulive,
  },
  data() {
    return {
      title: "Próximas Aulives",
      items: [
        {
          text: "Início",
          href: "/",
        },
        {
          text: "Aluno",
          href: "#",
        },
        {
          text: "Próximas Aulives",
          active: true,
        },
      ],
    };
  },
  mounted() {
    const aluno = JSON.parse(window.localStorage.getItem("aluno"));
    this.$nextTick(() => {
      this.$refs.proximaAulive.get(aluno.codusuario);
    });
  },
  methods: {},
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <ProximaAulive ref="proximaAulive" />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
